export default "__VITE_ASSET__CXNXwsmZ__"